module.exports = __webpack_public_path__ + "img/promotion-icon.c753e8da.svg";